export default "__VITE_ASSET__BdZj$pVF__"